import React from "react";
import classes from "./styles/style.module.css";
import { motion } from "framer-motion";
import CrossGroupImg from "../../../images/common/crossGroup.svg";
import CrossGroupImgDark from "../../../images/common/rulesImgdark.png";

const NoResultAlter = ({ className, text, dark }) => {
  return (
    <div className={className}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: -30 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate="visible"
        transition={{
          duration: 0.5,
          delay: 0.1,
        }}
      >
        <img
          src={dark ? CrossGroupImgDark : CrossGroupImg}
          alt="cross"
          className={classes.noResImg}
        />
      </motion.div>

      <motion.div
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate="visible"
        transition={{
          duration: 0.4,
          delay: 0.1,
        }}
      >
        <p className={`${classes.noResText} ${dark ? classes.dark : ""}`}>
          {text ? text : "موردی برای نمایش وجود ندارد"}
        </p>
      </motion.div>
    </div>
  );
};

export default NoResultAlter;
